import React, { useState, useEffect } from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';
import { AlertTriangle, ShieldCheck } from 'lucide-react';
import axiosInstance from '../../api/axiosConfig';

const AcknowledgementModal = ({ user }) => {
    const [criticalAnnouncement, setCriticalAnnouncement] = useState(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const checkPendingAnnouncements = async () => {
            try {
                // Fetch announcements with priority 'critical' that this user hasn't signed yet
                const res = await axiosInstance.get('/announcements/pending-critical');
                if (res.data.data) {
                    setCriticalAnnouncement(res.data.data);
                    setShow(true);
                }
            } catch (err) {
                console.error("Error checking acknowledgments", err);
            }
        };
        checkPendingAnnouncements();
    }, []);

    const handleAcknowledge = async () => {
        try {
            await axiosInstance.post('/announcements/acknowledge', {
                announcement_id: criticalAnnouncement.id
            });
            setShow(false);
        } catch (err) {
            alert("Failed to record acknowledgment. Please try again.");
        }
    };

    return (
        <Modal 
            show={show} 
            backdrop="static" 
            keyboard={false} 
            centered 
            size="lg"
            className="acknowledgment-modal"
        >
            <Modal.Header className="bg-danger text-white border-0">
                <Modal.Title className="d-flex align-items-center gap-2">
                    <AlertTriangle size={24} /> Urgent: Action Required
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <Badge bg="danger" className="mb-2">CRITICAL UPDATE</Badge>
                <h4 className="fw-bold">{criticalAnnouncement?.title}</h4>
                <div className="mt-3 p-3 bg-light rounded border">
                    {criticalAnnouncement?.message}
                </div>
                <p className="mt-4 text-muted small">
                    By clicking "I have read and agree," you acknowledge that you have understood the contents 
                     of this official company announcement. This action is recorded for compliance.
                </p>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button variant="danger" className="w-100 py-2 fw-bold" onClick={handleAcknowledge}>
                    <ShieldCheck size={18} className="me-2" /> I have read and agree
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AcknowledgementModal;